import React, { useEffect, useRef, useState } from "react";
import { ControlLabel } from "react-bootstrap";
import * as constants from "../../../EventSettings/constants";
import { loginSettingsScreens } from "../../constants/loginAndRegistrationPage";
import {
    getPrivacyOffers,
    getRegistrationFields,
    setVariablesForBlock,
} from "../../../EventSettings/utils";
import getCapitalizedLocale from "@platform/helpers/get-capitalized-locale";
import {
    EmailRequestHeader,
    RegistrationHeader,
    RegistrationSuccessHeader,
    RegistrationSuccessHeaderWithPreModeration
} from "@platform/components/Authentication/RegistrationHeader";
import EmailRequest from "@platform/components/Authentication/EmailRequest";
import RegistrationRequest from "@platform/components/Authentication/RegistrationRequest";
import EmailPasswordRequest from "@platform/components/Authentication/EmailPasswordRequest";
import InfoAuthentication from "@platform/components/Authentication/InfoAuthentication";
import GuestLogin from "@platform/components/Authentication/GuestLogin";
import Icons from "@platform/components/Icons";
import UIButton from "../../../../../../globalComponents/UIComponents/UIButton";

import './styles.scss';
import { ParticipationTypeSelectBlock } from "../../../../../../platform/src/blocks/ParticipationTypeSelectBlock";

const LoginAndRegistrationPreview = ({
    $locale,
    event,
    settings,
    screen,
    guest,
    onChange,
}) => {
    const authRef = useRef();
    const {moduleTheme, moduleAuth} = event;
    const {backgroundColor, textColor} = moduleTheme;
    const {backgroundImage, hideInfoBlock, changeSubstrate} = settings;
    const {getProperty} = $locale;
    const [isEmailRequestVisible, setEmailRequestVisible] = useState(true);

    const authBlockBackgroundColor = `#${(backgroundImage && !changeSubstrate) ? `${backgroundColor}cc` : `${textColor}0d`}`;
    const localeName = getCapitalizedLocale($locale.localeName);
    const registrationSubtitle = settings[`registrationSubtitle${localeName}`];
    const eventTitle = settings[`eventTitle${localeName}`];
    const eventSubtitle = settings[`eventSubtitle${localeName}`];
    const date = settings[`date${localeName}`];
    const showInfoBlock = (!hideInfoBlock && moduleAuth.require) || (!hideInfoBlock && !moduleAuth.require && event.participationType === 'hybrid');
    const isParticipationTypeSelectVisible = screen === constants.LOGIN_OPTION_PARTICIPATION_TYPE_SELECT;
    const registrationType = moduleAuth.registrationType === 'hybrid' && moduleAuth.require ? 'hybrid' : undefined;

    useEffect(() => {
        setEmailRequestVisible(!isParticipationTypeSelectVisible && (!screen || screen === constants.LOGIN_OPTION_INFO || screen === constants.LOGIN_OPTION_EMAIL_REQUEST));
    }, [screen]);

    useEffect(() => {
        setVariablesForBlock(authRef.current, moduleTheme);
    }, []);

    const styles = {
        backgroundColor: `#${backgroundColor}`,
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
    };

    return (
        <>
            <ControlLabel>
                Страница входа и регистрации на платформу
            </ControlLabel>
            <p>{loginSettingsScreens(guest)[screen]}</p>
            <div
                ref={authRef}
                className="authentication login-page"
                style={styles}
            >
                <div
                    className="authentication__content"
                    style={{
                        maxWidth: showInfoBlock ? '1080px' : ((moduleAuth.require || !isParticipationTypeSelectVisible) ? '800px' : '464px'),
                        backgroundColor: authBlockBackgroundColor,
                    }}
                >
                    <div className={`authentication__block-auth ${showInfoBlock ? 'authentication__block-auth--two-column' : ''} ${isParticipationTypeSelectVisible ? 'authentication__block-auth--center' : ''}`}>
                        {showInfoBlock && (
                            <InfoAuthentication
                                $locale={$locale}
                                posterImage={settings.posterImage ?? ''}
                                eventName={getProperty(event, 'name')}
                                eventTitle={eventTitle}
                                hideEventTitle={settings.hideEventTitle}
                                eventSubtitle={eventSubtitle}
                                hideEventSubtitle={settings.hideEventSubtitle}
                                date={date}
                                eventTimeStart={event.timeStart}
                                eventTimeStop={event.timeStop}
                                hideDate={settings.hideDate}
                                hideFormat={settings.hideFormat}
                                eventParticipationType={event.participationType}
                            />
                        )}
                        <div className="auth-container">
                            {
                                (moduleAuth.guest)
                                ? (
                                    isParticipationTypeSelectVisible ?
                                        <ParticipationTypeSelectBlock
                                            $locale={$locale}
                                            eventName={getProperty(event, 'name')}
                                            timeStart={event.timeStart}
                                            hideSubtitle={settings.hideParticipationTypeSubtitle ?? false}
                                            subtitle={getProperty(settings, 'participationTypeSubtitle')}
                                            hideInfoBlock={!showInfoBlock}
                                            participationTypeLabels={moduleAuth.participationFormatLabels ?? null}
                                            onSelect={() => {}}
                                        /> :
                                        <GuestLogin
                                            $locale={$locale}
                                            eventKey={event.eventKey}
                                            moduleAuth={moduleAuth}
                                            eventName={getProperty(event, 'name')}
                                            customDescription={getProperty(settings, 'loginSubtitle')}
                                            registrationFields={getRegistrationFields(event, $locale)}
                                            privacyOffer={getPrivacyOffers(event, $locale)}
                                            participationType={event.participationType}
                                            hideInfoBlock={hideInfoBlock}
                                            hideLoginSubtitle={settings.hideLoginSubtitle}
                                            timeStart={event.timeStart}
                                            authRequired={moduleAuth.require}
                                            registrationType={registrationType}
                                        />
                                ) : <>
                                    {isEmailRequestVisible && (
                                        <EmailRequestHeader
                                            eventName={getProperty(event, 'name')}
                                            hideInfoBlock={hideInfoBlock}
                                            $locale={$locale}
                                            timeStart={event.timeStart}
                                            customDescription={getProperty(settings, 'loginSubtitle')}
                                            hideLoginSubtitle={settings.hideLoginSubtitle}
                                            enterOnly={settings.enterOnly}
                                            authRequired={moduleAuth.require}
                                        >
                                            <EmailRequest
                                                $locale={$locale}
                                                eventKey={event.eventKey}
                                                allowAnonymousLogin={!moduleAuth?.require && moduleAuth?.anonymous}
                                                enterOnly={settings.enterOnly}
                                                onSuccess={() => onChange(constants.LOGIN_OPTION_REGISTRATION)}
                                            />
                                        </EmailRequestHeader>
                                    )}
                                    {screen === constants.LOGIN_OPTION_REGISTRATION && (
                                        <RegistrationHeader
                                            $locale={$locale}
                                            hideInfoBlock={hideInfoBlock}
                                        >
                                            {(!settings.hideRegistrationSubtitle && registrationSubtitle) && (
                                                <p>{registrationSubtitle}</p>
                                                )}
                                            <RegistrationRequest
                                                $locale={$locale}
                                                eventKey={event.eventKey}
                                                allowAnonymousLogin={!moduleAuth?.require && moduleAuth?.anonymous}
                                                email={'test@comdi.com'}
                                                participationType={event.participationType}
                                                fields={getRegistrationFields(event, $locale)}
                                                onSuccess={() => onChange(constants.LOGIN_OPTION_REGISTRATION_SUCCESS)}
                                                onReset={() => onChange(constants.LOGIN_OPTION_EMAIL_REQUEST)}
                                                participationFormatLabels={moduleAuth.participationFormatLabels ?? []}
                                                localeNameInPascalCase={localeName}
                                                eventPremoderation={moduleAuth.accessPreModeration}
                                                registrationType={registrationType}
                                            />
                                        </RegistrationHeader>
                                    )}
                                    {screen === constants.LOGIN_OPTION_REGISTRATION_SUCCESS && (
                                        <RegistrationSuccessHeader
                                            email={'test@comdi.com'}
                                            isRegisteredNow={true}
                                            $locale={$locale}
                                            hideSuccessTitle={settings.hideSuccessTitle}
                                            successTitle={getProperty(settings, 'successTitle')}
                                            hideSuccessSubtitle={settings.hideSuccessSubtitle}
                                            successSubtitle={getProperty(settings, 'successSubtitle')}
                                        >
                                            <EmailPasswordRequest
                                                $locale={$locale}
                                                eventKey={event.eventKey}
                                                email={'test@comdi.com'}
                                            />
                                        </RegistrationSuccessHeader>
                                    )}
                                    {screen === constants.LOGIN_OPTION_REGISTRATION_PREMODERATION && (
                                        <RegistrationSuccessHeaderWithPreModeration
                                            eventName={getProperty(event, 'name')}
                                            email={'test@comdi.com'}
                                            $locale={$locale}
                                            hideAcceptedTitle={settings.hideAcceptedTitle}
                                            acceptedTitle={getProperty(settings, 'acceptedTitle')}
                                            hideAcceptedSubtitle={settings.hideAcceptedSubtitle}
                                            acceptedSubtitle={getProperty(settings, 'acceptedSubtitle')}
                                        >
                                            <UIButton
                                                type="button"
                                                size="large"
                                                color="primary"
                                                onClick={() => onChange(constants.LOGIN_OPTION_INFO)}
                                            >
                                                {$locale.get('guide.exit')}
                                            </UIButton>
                                        </RegistrationSuccessHeaderWithPreModeration>
                                    )}
                                    {isParticipationTypeSelectVisible &&
                                        <ParticipationTypeSelectBlock
                                            $locale={$locale}
                                            eventName={getProperty(event, 'name')}
                                            timeStart={event.timeStart}
                                            hideSubtitle={settings.hideParticipationTypeSubtitle ?? false}
                                            subtitle={getProperty(settings, 'participationTypeSubtitle')}
                                            hideInfoBlock={!showInfoBlock}
                                            participationTypeLabels={moduleAuth.participationFormatLabels ?? null}
                                            onSelect={() => {}}
                                        />
                                    }
                                </>
                            }
                        </div>
                    </div>
                    {event.moduleBranding.showComdiBanner && (
                        <footer className="auth-footer">
                            <a href="https://www.comdi.com/?utm_source=platform&utm_medium=registration_form&utm_campaign=users" target="_blank">
                                <Icons name="comdi_logo" />
                            </a>
                        </footer>
                    )}
                </div>
            </div>
        </>
    );
};

export default LoginAndRegistrationPreview;
